export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Development-Gray-a0c55c75db67d7aabf75a3d5702a61b5.svg";